import LegalNotices from '../components/LegalNotices'

function Home({ t, lang }) {
    return (
    <main className="page-container bg-custom">
        <div className='container text-center'>
            <h1 className='page-title'>{t("nav_legal_notices").toUpperCase()}</h1>
            <LegalNotices t={t} lang={lang} />
        </div>
    </main>
    );
}

export default Home;